import { useContext, useEffect, useState } from "react";
import { LoginContext } from "../../../context/LoginContext";
import { Link } from "react-router-dom";
import { PREMIUM_PLANS, planFeatures } from "../../../utils/premiumPlans";


const PricingPlanCard = () => {



    const { userId, isLoggedIn } = useContext(LoginContext);
    const [plan,setPlan]=useState("");

  
  
  
    useEffect(() => {
      if (!isLoggedIn) {
        setPlan("/login");
      }
      else{
        setPlan(`/upgrade/${userId}`);
      }
    }, [isLoggedIn, userId]);




  return (
    <div className="pricing-section container text-center">
      <style>
        {`/* PricingPlanCard.css */
.badge{
 display: inline-block;
  background-color: #fce4ec;
  color: #333;
  padding: 5px 15px;
  border-radius: 5px;
  font-size: 14px;
  margin-bottom: 10px;}
.pricing-section {
padding-top:150px;
padding-bottom:50px;
}

.title {
  font-size: 2rem;
}

.description {
  max-width: 600px;
  margin: 0 auto 2rem;
  font-size: 0.95rem;
  color: #666;
}

.pricing-card {
  max-width: 350px;
  border-radius: 12px;
  padding: 2rem 1.5rem;
  background: #fff;
}

.card-title {
  font-size: 1.5rem;
  font-weight: 600;
}

.card-subtitle {
  font-size: 0.9rem;
}

.price {
  font-size: 1.4rem;
  margin-bottom: 1rem;
}

.feature {
  font-size: 0.9rem;
  margin-bottom: 0.5rem;
}

@media (max-width: 768px) {
  .pricing-section {
    padding-top: 12px;
    padding-bottom: 32px;
  }
}

  .bg-warning {
    --bs-bg-opacity: 1;
    background-color: #F9EBB2;
}
`}
      </style>
      <div className="badge  text-dark mb-3">Pricing</div>
      <h3 className="title ">
        {/* Get Started<br /> */}
        Pick Your <span className="text-danger">Plan Now</span>
      </h3>
      {/* <p className="description">
        Lorem Ipsum Is Simply Dummy Text Of The Printing And Typesetting Industry.
      </p> */}


      <div className="row justify-content-center">

        {PREMIUM_PLANS.map((item) => (
          <div className="col-md-4 my-3" key={item.code}>
            <div className="card mx-auto pricing-card shadow-sm h-100">
              <div className="card-body">
                <span
                  className="badge bg-warning text-dark mb-2"
                  style={{ visibility: item.popular ? 'visible' : 'hidden' }}
                >
                  Most Popular Plan
                </span>
                <h5 className="card-title">Premium</h5>
                <p className="card-subtitle mb-3 text-muted" style={{ color: "#A16304" }}>India's Trusted Matrimony Services</p>
                <Link to={plan} className="btn btn-danger w-100 mb-3">Get Started</Link>
                <h4 className="price">₹ {item.price} /- <span className="text-muted">{item.validity}</span></h4>
                <ul className="list-unstyled text-start mt-4">
                  {planFeatures(item).map((feature) => (
                    <li className="feature" key={feature}><i className="text-success me-2">✔</i>{feature}</li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        ))}

      </div>

    </div>
  );
};

export default PricingPlanCard;
